import React from 'react';
import './enhance-your-visit.less';
import { useClassName } from 'common/hooks';
import { EnhanceHeader } from './EnhanceHeader/EnhanceHeader';
import {
  getContentfulAssetUrlandAlt,
  getContentfulField,
} from 'common/components';
import { UpgradesAccordion } from './UpgradesAccordion/UpgradesAccordion';
import { GetPremiumPass } from './GetPremiumPass/GetPremiumPass';
import { getStylesByPrefix } from 'public/screens/CustomLandingPage/utils';
import useCustomStyle from 'public/screens/CustomLandingPage/hooks';

export const EnhanceYourVisit = ({ venue }) => {
  const className = useClassName('EnhanceYourVisit');
  const secondaryColor = getContentfulField(venue.parkScreen?.secondaryColor);
  const tertiaryColor = getContentfulField(venue.parkScreen?.tertiaryColor);

  const enhanceVisitCardFields = getContentfulField(
    venue.parkScreen?.enhanceVisitCard
  ).fields;

  const rawSettings = getContentfulField(enhanceVisitCardFields.settings) || [];
  const processedSettings = rawSettings.map((setting) => ({
    ...setting,
    fields: {
      key: getContentfulField(setting.fields?.key),
      name: getContentfulField(setting.fields?.name),
      value: getContentfulField(setting.fields?.value),
      mobileValue: getContentfulField(setting.fields?.mobileValue),
      tabletValue: getContentfulField(setting.fields?.tabletValue),
      desktopValue: getContentfulField(setting.fields?.desktopValue),
    },
  }));

  const [, style] = useCustomStyle(processedSettings);
  console.log({ processedSettings });

  console.log({ enhanceVisitCardFields, processedSettings, style });

  const petAssetFields = getContentfulField(
    venue.parkScreen?.enhanceYourVisitPet
  ).fields;
  const petImage = {
    source: {
      mobile: getContentfulAssetUrlandAlt(petAssetFields.mobile),
      desktop: getContentfulAssetUrlandAlt(petAssetFields.desktop),
    },
    styles: getStylesByPrefix('--pet-image-', style),
  };

  const upgradesCarouselFields = getContentfulField(
    venue.parkScreen?.upgradesCarousel
  ).fields;

  const upgradesCarousel = {
    slides: getContentfulField(upgradesCarouselFields.slides).map((slide) => {
      const links = getContentfulField(slide.fields.links);
      const link =
        links && links.length > 0
          ? {
              label: getContentfulField(links[0].fields.label),
              url: getContentfulField(links[0].fields.url),
              type: getContentfulField(links[0].fields.type),
            }
          : null;

      const carouselFields = getContentfulField(slide.fields.carousel).fields;

      const items = getContentfulField(carouselFields.slides).map(
        (slideItem) => {
          const asset = {
            mobile: getContentfulAssetUrlandAlt(slideItem.fields.mobile),
            desktop: getContentfulAssetUrlandAlt(slideItem.fields.desktop),
          };
          return asset;
        }
      );

      const featuresValues = slide.fields.settings
        ? getContentfulField(slide.fields.settings).filter(
            (setting) => getContentfulField(setting.fields.key) === 'feature'
          )
        : [];

      const features = featuresValues.map((feature) => {
        return {
          text: getContentfulField(feature.fields.richTextValue),
          icon: getContentfulField(feature.fields.value),
        };
      });

      return {
        title: getContentfulField(slide.fields.title),
        subtitle: getContentfulField(slide.fields.subtitle),
        description: getContentfulField(slide.fields.description),
        items,
        features,
        link,
      };
    }),
  };

  const backgroundFields = getContentfulField(
    enhanceVisitCardFields.asset
  ).fields;
  const iconFields = getContentfulField(enhanceVisitCardFields.icon).fields;
  const logoFields = getContentfulField(
    enhanceVisitCardFields.logoOverlay
  ).fields;

  const links = getContentfulField(enhanceVisitCardFields.links);
  const link =
    links && links.length > 0
      ? {
          label: getContentfulField(links[0].fields.label),
          url: getContentfulField(links[0].fields.url),
          type: getContentfulField(links[0].fields.type),
        }
      : null;

  const mobileFields = getContentfulField(backgroundFields.mobile).fields;
  const mobileSize = getContentfulField(mobileFields.file).details.image;
  const tabletFields = getContentfulField(backgroundFields.tablet).fields;
  const tabletSize = getContentfulField(tabletFields.file).details.image;
  const desktopFields = getContentfulField(backgroundFields.desktop).fields;
  const desktopSize = getContentfulField(desktopFields.file).details.image;

  const enhanceVisitCard = {
    background: {
      mobile: {
        source: getContentfulAssetUrlandAlt(backgroundFields.mobile),
        size: mobileSize,
      },
      tablet: {
        source: getContentfulAssetUrlandAlt(backgroundFields.tablet),
        size: tabletSize,
      },
      desktop: {
        source: getContentfulAssetUrlandAlt(backgroundFields.desktop),
        size: desktopSize,
      },
    },
    title: getContentfulField(enhanceVisitCardFields.title),
    subtitle: getContentfulField(enhanceVisitCardFields.subtitle),
    description: getContentfulField(enhanceVisitCardFields.description),
    petImage: getContentfulField(iconFields.file),
    logoImage: getContentfulField(logoFields.file),
    link,
  };

  return (
    <div
      id="upgrades"
      className={className('container')}
      style={{ backgroundColor: tertiaryColor }}>
      <div
        className={className('container__wrapper')}
        style={{ backgroundColor: secondaryColor }}>
        <div className={className('container__inner')}>
          <EnhanceHeader
            title={enhanceVisitCard.title || 'Enhance Your Visit'}
            description={
              enhanceVisitCard.subtitle ||
              'Your private retreat is just steps away. Skyboxes, Cabanas, and Daybeds offer comfort, style, and relax at your own pace.'
            }
            petImage={petImage}
          />
          <UpgradesAccordion slides={upgradesCarousel?.slides} />
          <GetPremiumPass enhanceVisitCard={enhanceVisitCard} />
        </div>
      </div>
    </div>
  );
};
